import * as Yup from "yup";

import i18next from "i18next";

export function getFirstFillFormSchema(isMou, isForeigner) {
  return Yup.object({
    job_type:
      isMou || isForeigner
        ? Yup.string().nullable()
        : Yup.string().required(
            i18next.t("fillForm:validation.jobTypeRequired")
          ),
    job_name: Yup.string().required(
      i18next.t("fillForm:validation.jobRequired")
    ),
    current_company: Yup.string().required(
      i18next.t("fillForm:validation.currentCompanyRequired")
    ),
    job_experience_in_year: Yup.number(
      i18next.t("fillForm:validation.numberRequired")
    ).min(0.1, i18next.t("fillForm:validation.jobExperience")),
    monthly_income: Yup.number(
      i18next.t("fillForm:validation.numberRequired")
    ).min(1, i18next.t("fillForm:validation.monthlyIncome")),
    monthly_debt: Yup.number(
      i18next.t("fillForm:validation.numberRequired")
    ).min(1, i18next.t("fillForm:validation.monthlyExpense")),
    out_time_income: Yup.number(
      i18next.t("fillForm:validation.numberRequired")
    ),
    other_income: Yup.number(i18next.t("fillForm:validation.numberRequired")),
    income_type: Yup.string().required(
      i18next.t("fillForm:validation.incomeType")
    ),
    monthly_outcome: Yup.number(
      i18next.t("fillForm:validation.numberRequired")
    ).min(0, i18next.t("fillForm:validation.monthlyExpense")),
    debt_amount: Yup.number(i18next.t("fillForm:validation.numberRequired"))
      .min(0, i18next.t("fillForm:validation.debtAmount"))
      .nullable(),
    hire_type: Yup.string().required(i18next.t("fillForm:validation.hireType")),
    total_debt: Yup.number(i18next.t("fillForm:validation.numberRequired"))
      .min(0, i18next.t("fillForm:validation.debtAmount"))
      .nullable(),
    other_job_name: Yup.string(),
    jobLevel: Yup.string().required(i18next.t("fillForm:validation.jobLevel")),
  }).test(
    "other_job_name",
    i18next.t("fillForm:validation.otherJobRequired"),
    (formData) => {
      if (formData.job_name === i18next.t("fillForm:validation.other")) {
        return formData.other_job_name?.length > 0;
      }
      return true;
    }
  );
}

export function getFirstFillFormInitialValues() {
  // const defaultDebtAmount = 0;
  return {
    job_name: "",
    current_company: "",
    hire_type: "",
    job_experience_in_year: 0,
    monthly_income: 0,
    out_time_income: 0,
    other_income: 0,
    income_type: i18next.t("job:incomeMonthly"),
    monthly_outcome: 0, // FIXED
    debt_amount: 0, // FIXED
    monthly_debt: 0, // FIXED
    total_debt: 0, // FIXED
  };
}
